import { Window } from '@execonline-inc/browser-window.private';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useState } from 'react';
import { request, retryOnSessionExpiration } from '../../Appy';
import { rootResourceStore } from '../../RootResourceStore';
import { T } from '../../Translations';
import InfoIcon from '../Cutesies/InfoIcon';

interface Props {
  impersonatingBy: Maybe<string>;
}

// A full page load drops every store that still holds the impersonated user's data.
const goHome = (): void => {
  Window.redirect('/');
};

const ImpersonationMessage: React.FC<Props> = ({ impersonatingBy }) => {
  const [stopping, setStopping] = useState(false);

  const stopImpersonating = (): void => {
    setStopping(true);
    rootResourceStore
      .findLinkT('logout')
      .andThen((link) => retryOnSessionExpiration(request(link, {})))
      .fork(goHome, goHome);
  };

  return impersonatingBy
    .map((email) => (
      <div
        role="region"
        aria-label="Admin impersonation notice"
        className="flex items-center justify-between border-b-2 border-solid border-teal-400 bg-teal-50 px-8 py-2"
        data-intercom-target="impersonation-banner"
      >
        <div className="flex items-center gap-3">
          <InfoIcon />
          <span className="text-sm text-teal-900">
            <T kind="Impersonating by {{emailAddress}}" emailAddress={email} />
          </span>
        </div>
        <button
          type="button"
          onClick={stopImpersonating}
          disabled={stopping}
          className="rounded-md border border-solid border-teal-600 bg-white px-3 py-1 text-sm font-medium text-teal-700 hover:bg-teal-100 disabled:opacity-50"
          data-intercom-target="stop-impersonating-button"
        >
          {stopping ? <T kind="Stopping…" /> : <T kind="Stop Impersonating" />}
        </button>
      </div>
    ))
    .getOrElse(() => <></>);
};

export default observer(ImpersonationMessage);
